import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { bonuses, outcomes } from '../data/kit';
export function Bonuses() {
  return <section className="bg-lila-100 py-9 md:py-16 px-4" data-id="element-12" data-mp="pjg5q15wl80x">
      <div className="max-w-5xl mx-auto" data-id="element-13" data-mp="avlbuhg5sxm9">
        <div className="text-center mb-6 md:mb-10 max-w-3xl mx-auto" data-id="element-14" data-mp="aujyg6bo7z1d">
          <h2 className="font-serif text-[25px] md:text-[42px] font-bold text-wine tracking-tight leading-[1.12]" data-id="element-15" data-mp="ftefp3tzpfjd">
            4 BONOS PARA ENTENDER MEJOR TU CUERPO Y ACOMPAÑAR EL PROCESO 🎁
          </h2>
          <p className="text-ink-muted text-[15px] md:text-lg leading-snug mt-2.5 md:mt-4" data-id="element-16" data-mp="5x1me72cx3p5">
            No son material de relleno. Cada bono resuelve una parte diferente
            del problema.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-17" data-mp="3t0yc046126z8">
          {bonuses.map((bono, i) => <article key={bono.title} className="flex flex-col rounded-2xl border border-lila-200 bg-white overflow-hidden" data-id="element-18" data-mp="1m85lnlxyzqk9" data-mpi={i}>
              {bono.image && <div className="bg-cream-50 aspect-[4/3] md:aspect-[3/4] overflow-hidden" data-id="element-19" data-mp="3icbtvu6x5tnd">
                  <img src={bono.image} alt={`Vista previa de ${bono.title}`} className="w-full h-full object-cover object-top" loading="lazy" decoding="async" data-id="element-20" data-mp="3df3d9y1f5xo8" />
                </div>}
              <div className="flex gap-3.5 md:flex-col md:gap-0 p-4 md:p-6" data-id="element-21" data-mp="2zhezfa5rrqso">
                <p className="font-serif text-3xl md:text-4xl font-bold text-lila-300 leading-none tabular-nums shrink-0" data-id="element-22" data-mp="2uibt7me1zej4">
                  {String(i + 1).padStart(2, '0')}
                </p>
                <div className="min-w-0" data-id="element-23" data-mp="33fuk37edon2x">
                  <h3 className="font-serif font-bold text-wine text-base md:text-lg leading-snug md:mt-3" data-id="element-24" data-mp="nprl7bkw0vmq">
                    {bono.title}
                  </h3>
                  <p className="font-bold text-lila-600 text-[15px] leading-snug mt-1" data-id="element-25" data-mp="iqom07rl9jmo">
                    {bono.lead}
                  </p>
                  <p className="text-ink-muted text-sm leading-snug md:leading-relaxed mt-1.5" data-id="element-26" data-mp="3hhhs6rc3c78n">
                    {bono.desc}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="max-w-3xl mx-auto mt-10 md:mt-16" data-id="element-27" data-mp="3qi5vaqzy4n6r">
          <h2 className="font-serif text-[24px] md:text-[38px] font-bold text-center text-wine leading-[1.12] tracking-tight" data-id="element-28" data-mp="2tsyl2f4s20i5">
            NO NECESITÁS ENTRENAR MÁS.{' '}
            <span className="block text-rose-600 mt-1" data-id="element-29" data-mp="2xrnszs71qpue">
              NECESITÁS SABER QUÉ ESTÁS HACIENDO.
            </span>
          </h2>
          <p className="text-center text-[15px] md:text-lg text-ink-muted leading-snug mt-3 md:mt-5 max-w-xl mx-auto" data-id="element-30" data-mp="37k3aypicfefa">
            Suelo Pélvico Fuerte +40 fue diseñado para que puedas abrir la guía
            y saber:
          </p>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mt-5 md:mt-7" data-id="element-31" data-mp="2f1xxt3zdg21y">
            {outcomes.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl border border-lila-200 bg-white px-4 py-3 md:px-5 md:py-4" data-id="element-32" data-mp="27hncl420zcu4">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-sage-600 shrink-0" data-id="element-33" data-mp="1xnwuqi0em0ne" />
                <span className="text-ink text-[15px] md:text-base font-medium leading-snug" data-id="element-34" data-mp="1tjyuu5398lta">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}